var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.992,2A8,8,0,1,0,18,10,8,8,0,0,0,9.992,2Zm5.544,4.8h-2.36a12.519,12.519,0,0,0-1.1-2.848A6.424,6.424,0,0,1,15.536,6.8ZM10,3.632A11.269,11.269,0,0,1,11.528,6.8H8.472A11.269,11.269,0,0,1,10,3.632ZM3.808,11.6a6.258,6.258,0,0,1,0-3.2h2.7A13.212,13.212,0,0,0,6.4,10a13.212,13.212,0,0,0,.112,1.6Zm.656,1.6h2.36a12.519,12.519,0,0,0,1.1,2.848A6.389,6.389,0,0,1,4.464,13.2Zm2.36-6.4H4.464A6.389,6.389,0,0,1,7.928,3.952,12.519,12.519,0,0,0,6.824,6.8ZM10,16.368A11.269,11.269,0,0,1,8.472,13.2h3.056A11.269,11.269,0,0,1,10,16.368ZM11.872,11.6H8.128A11.77,11.77,0,0,1,8,10a11.668,11.668,0,0,1,.128-1.6h3.744A11.668,11.668,0,0,1,12,10,11.77,11.77,0,0,1,11.872,11.6Zm.2,4.448a12.519,12.519,0,0,0,1.1-2.848h2.36A6.424,6.424,0,0,1,12.072,16.048ZM13.488,11.6A13.212,13.212,0,0,0,13.6,10a13.212,13.212,0,0,0-.112-1.6h2.7a6.258,6.258,0,0,1,0,3.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLanguage);
export default __webpack_public_path__ + "static/media/icon_language.9736470e71a74286ff59ffe006641a23.svg";
export { ForwardRef as ReactComponent };